import { Link } from 'react-router-dom';
import { hotAnime } from '@/mocks/anime';

export default function HotRecommend() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
              热门推荐
            </h2>
            <p className="text-foreground-600 text-sm">精选高分动漫，大家都在看</p>
          </div>
          <Link
            to="/category/riman"
            className="flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            更多推荐 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {hotAnime.map((anime) => (
            <Link
              key={anime.id}
              to={`/article/${anime.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={anime.imageUrl}
                  alt={anime.title}
                  title={`${anime.title} - 51动漫热门推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 right-2 px-2 py-1 rounded-md bg-background-950/70 text-accent-400 text-xs font-semibold">
                  {anime.rating}
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
                  <span className="text-background-50 text-xs">{anime.updateTo}</span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-medium text-foreground-950 text-sm md:text-base group-hover:text-primary-600 transition-colors line-clamp-1">
                  {anime.title}
                </h3>
                <p className="text-foreground-500 text-xs mt-1">{anime.category}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}